import { render } from "./QuestDialog12.vue?vue&type=template&id=5adc61e4"
import script from "./QuestDialog12.vue?vue&type=script&lang=js"
export * from "./QuestDialog12.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog12.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5adc61e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5adc61e4', __exports__)) {
    api.reload('5adc61e4', __exports__)
  }
  
  module.hot.accept("./QuestDialog12.vue?vue&type=template&id=5adc61e4", () => {
    api.rerender('5adc61e4', render)
  })

}


export default __exports__